import { useFeatureFlags } from '@brightdrop/feature-flags-client';
import { useEntitlements } from '@gm-commercial/entitlements-client';
import { EMER_FLAG } from '~/common/models/featureFlags.model';
import { ProductCodes } from '~/common/models/plans.model';

/**
 * Whether the org can set up emergency notifications: the EMER flag is on and
 * the org has Protect, alone or in One Fleet. Delivery is still gated per
 * vehicle by the platform, so this only decides whether the Emergency
 * notifications show.
 * @returns `hasEmerAccess`, and `isReady` once entitlements have loaded
 */
export const useEmerNotificationsAccess = () => {
  const { getFlag } = useFeatureFlags();
  const { hasProduct, isReady } = useEntitlements();
  const isFlagOn = !!getFlag(EMER_FLAG);
  const hasProtect =
    hasProduct(ProductCodes.OSS) || hasProduct(ProductCodes.OSOF);

  return { hasEmerAccess: isFlagOn && isReady && hasProtect, isReady };
};
